
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[hostname]/ISR/[[...slug]]",
      function () {
        return require("private-next-pages/_sites/[hostname]/ISR/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[hostname]/ISR/[[...slug]]"])
      });
    }
  